/** One planned-work board column scale. Tenant, embedded, and portal manifests all import these. */
export const PlannedWorkCol = {
  /** Plan / template / task name — the row title. */
  title: { minWidth: 360, flex: 2 },
  /** Service Plan column when the row is not itself a plan. */
  plan: { minWidth: 360, flex: 1 },
  customer: { minWidth: 200 },
  site: { minWidth: 260, flex: 1 },
  date: { width: 130, flex: 0 },
  dateTime: { minWidth: 185, flex: 0 },
  tag: { width: 150, flex: 0 },
  status: { minWidth: 160 },
  crew: { minWidth: 160 },
  frequency: { width: 110, flex: 0 },
  line: { minWidth: 160 },
  job: { minWidth: 130 },
  description: { minWidth: 220, flex: 1 },
  updated: { width: 140, flex: 0 },
} as const;
